import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import {
  formatTime,
  getFormattedDateString,
  hasPermission,
} from "utility/helpers";
import {
  StyledEyeIcon,
  StyledEditIcon,
  StyledTrashIcon,
  AddCommentBtn,
  ViewCommentBtn,
  CellText,
} from "assets/js/Styles";
import styled from "styled-components";
import { EDIT_ACTION } from "constants/actions";

const CommentsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  position: relative;

  &:has(.unread-msgs) {
    bottom: 10px;
  }
`;

const eventColumns = ({
  navigate,
  handleDeleteAction,
  setCommentId,
  fetchComments,
  toggleModal,
}) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      style: { paddingLeft: 0, paddingRight: 0 },
      cell: () => null,
    },
    {
      name: "Event Name",
      selector: ({ eventName }) => eventName,
      identifier: "eventName",
      grow: 4,
      sortable: true,
      cell: ({ eventName }) => <CellText>{eventName}</CellText>,
    },
    {
      name: "Date Period",
      selector: ({ eventStartDate }) => eventStartDate,
      identifier: "eventStartDate",
      grow: 2,
      sortable: true,
      width: "210px",
      cell: ({ eventStartDate, eventEndDate }) => (
        <CellText>
          {getFormattedDateString(eventStartDate, "MMM dd, yyyy")}
          {" - "}
          {getFormattedDateString(eventEndDate, "MMM dd, yyyy")}
        </CellText>
      ),
    },
    {
      name: "Time",
      selector: ({ eventStartTime }) => eventStartTime,
      identifier: "eventStartTime",
      grow: 1,
      sortable: true,
      cell: ({ eventStartTime, eventEndTime }) => (
        <CellText>
          {formatTime(eventStartTime)}
          {" - "}
          {formatTime(eventEndTime)}
        </CellText>
      ),
      width: "170px",
    },
    {
      name: "Venue",
      selector: ({ eventVenue }) => eventVenue,
      identifier: "eventVenue",
      grow: 3,
      sortable: true,
      cell: ({ eventVenue }) => <CellText>{eventVenue}</CellText>,
    },
    {
      name: "Invitees",
      selector: ({ totalParticipants }) => totalParticipants,
      identifier: "totalParticipants",
      sortable: true,
      cell: ({ totalParticipants }) => <CellText>{totalParticipants}</CellText>,
    },
    {
      name: "Confirmed",
      selector: ({ numberOfConfirmed }) => numberOfConfirmed,
      identifier: "numberOfConfirmed",
      sortable: true,
      cell: ({ numberOfConfirmed }) => <CellText>{numberOfConfirmed}</CellText>,
    },
    {
      name: "Declined",
      selector: ({ numberOfDeclined }) => numberOfDeclined,
      identifier: "numberOfDeclined",
      sortable: true,
      cell: ({ numberOfDeclined }) => <CellText>{numberOfDeclined}</CellText>,
    },
    {
      name: "No Response",
      selector: ({ numberOfNoResponse }) => numberOfNoResponse,
      identifier: "numberOfNoResponse",
      sortable: true,
      cell: ({ numberOfNoResponse }) => (
        <CellText>{numberOfNoResponse}</CellText>
      ),
    },
    {
      name: "RSVP Date",
      selector: ({ rsvpStartDate }) => rsvpStartDate,
      identifier: "rsvpStartDate",
      grow: 2,
      sortable: true,
      width: "210px",
      cell: ({ rsvpStartDate, rsvpEndDate }) => (
        <CellText>
          {getFormattedDateString(rsvpStartDate, "MMM dd, yyyy")}
          {" - "}
          {getFormattedDateString(rsvpEndDate, "MMM dd, yyyy")}
        </CellText>
      ),
    },
    {
      name: "Remarks",
      selector: ({ remarks }) => remarks,
      identifier: "remarks",
      grow: 2,
      width: "170px",
      cell: ({ hasComments, id }) => (
        <CommentsContainer>
          {hasComments === 1 && hasPermission("comment-view") && (
            <ViewCommentBtn
              color="primary"
              size="sm"
              onClick={() => {
                fetchComments(id);
                setCommentId(id);
                toggleModal();
              }}
            >
              {"View Comment"}
            </ViewCommentBtn>
          )}
          {hasComments === 0 && hasPermission("comment-create") && (
            <AddCommentBtn
              size="sm"
              onClick={() => {
                setCommentId(id);
                toggleModal();
              }}
            >
              {"Add Comment"}
            </AddCommentBtn>
          )}
        </CommentsContainer>
      ),
    },
    {
      name: "Actions",
      selector: (row) => row?.id,
      sortable: false,
      width: "120px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row, index) => (
        <>
          {hasPermission("event-view") && (
            <>
              <StyledEyeIcon
                size={16}
                id={`view-row--${index}`}
                onClick={() => {
                  navigate(`/events/${row.id}/details`, {
                    state: { event: row },
                  });
                }}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`view-row--${index}`}
              >
                {"View"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("event-update") && (
            <>
              <StyledEditIcon
                size={16}
                id={`edit-row--${index}`}
                onClick={() => {
                  navigate("/events/edit", {
                    state: { row, action: EDIT_ACTION },
                  });
                }}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`edit-row--${index}`}
              >
                {"Edit"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("event-delete") && (
            <>
              <StyledTrashIcon
                size={16}
                id={`delete-row--${index}`}
                onClick={() => handleDeleteAction(row)}
              />
              <UncontrolledTooltip
                placement="right"
                target={`delete-row--${index}`}
              >
                {"Delete"}
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
    },
  ];
};

export default eventColumns;
